import React from 'react';

const AccessDenied: React.FC = () => {
  return (
    <div style={styles.container}>
      <h2 style={styles.message}>No tienes los permisos suficientes para visitar esta página.</h2>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    //height: '100vh', // Full viewport height
    backgroundColor: '#f8d7da', // Light red background for emphasis
    color: '#721c24', // Dark red text color
    textAlign: 'center' as 'center', // Center the text
  },
  message: {
    fontSize: '24px', // Adjust font size as needed
  },
};

export default AccessDenied;